(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mydab-range"] && !Shopify.designMode) return;
  try {
    
/*
 * The size chips, and nothing else. Vessel's own variant picker works exactly this way —
 * the radios carry the variant id in a data attribute and the script writes it into the
 * hidden input the cart form posts — so this is the theme's mechanism at card scale, not a
 * second one.
 *
 * Delegated at the document because Shopify concatenates every section's script block into
 * one file that runs once: a listener bound to elements at load would miss any card the
 * theme editor re-renders.
 *
 * The price is moved by the same handler that moves the variant id, deliberately. Swapping
 * the price in CSS would show a size's price next to a form still holding another size's
 * id if this file never ran — a wrong number that looks right. Moving both together means
 * the card is either fully live or fully at its default, and never lying.
 */
(function () {
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.classList || !input.classList.contains('mdr__chip-input')) return;

    var card = input.closest('.mdr__card');
    if (!card) return;

    var field = card.querySelector('input[name="id"]');
    if (field && input.dataset.variantId) field.value = input.dataset.variantId;

    var price = card.querySelector('[data-mdr-price]');
    if (price && input.dataset.price) price.textContent = input.dataset.price;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mydab-videos"] && !Shopify.designMode) return;
  try {
    
  // One delegated listener for every MyDab videos section on the page. Shopify includes a
  // section type's script once per page, not once per instance, so nothing here may assume
  // there is only one section or only one video in it.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest ? event.target.closest('.mdv__facade') : null;
    if (!trigger) return;

    var media = trigger.closest('.mdv__media');
    var src = trigger.getAttribute('data-embed');
    if (!media || !src) return;

    // The embed is created here and nowhere else: until this click, the page has made no
    // request to YouTube or Vimeo at all. autoplay in the URL is the response to the press.
    var frame = document.createElement('iframe');
    frame.className = 'mdv__frame';
    frame.setAttribute('src', src);
    frame.setAttribute('title', trigger.getAttribute('data-title') || '');
    frame.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
    frame.setAttribute('allowfullscreen', 'allowfullscreen');

    trigger.remove();
    media.appendChild(frame);

    // Focus was on the button that just went away; move it to the player rather than dropping
    // it back to the top of the document.
    if (typeof frame.focus === 'function') frame.focus();
  });

  } catch(e) { console.error(e); }
})();
})();
